// src/components/layout/Layout.tsx
import React from 'react';
import Header from './Header'; // Adjust the path as necessary
import Footer from './Footer';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
